export default __webpack_public_path__ + "static/media/mehmetflix.a27f2a75.png";